/* El Laguito 2026-10-18: live shipping estimate in the cart drawer and on /cart.
   Asks Shopify for the real rate for the cart's current contents, by province, so the
   shopper sees the shipping cost before checkout instead of at it. Uses the store's own
   shipping profiles (/cart/shipping_rates.json), so it is always the same figure checkout
   will charge for that province. Inserted after the "Taxes ... calculated at checkout" note;
   re-inserted whenever the cart drawer re-renders. Fails quietly (falls back to the note).
   2026-10-25: follows the postal code checked in the drawer's FedEx strip. window.elcShipEstPostal(postal)
   maps the FSA (first letter) to its province, selects it, and quotes Shopify for that exact postal code,
   so the FedEx comparison and the real charge always describe the same destination. A postal code
   remembered by the drawer (localStorage elgFedexEta, 24 h) is picked up on load as well. */
(function () {
  if (window.__elcShipEst) return;
  window.__elcShipEst = true;

  var FR = (document.documentElement.lang || '').indexOf('fr') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'elc_ship_prov';
  var POSTAL_KEY = 'elc_ship_postal';
  /* Province -> representative postal code (rates are set per province, not postal code). */
  var PROV = [
    ['Ontario', 'ON', 'L5T 1A1', 'Ontario'],
    ['Quebec', 'QC', 'H2X 1Y4', 'Québec'],
    ['British Columbia', 'BC', 'V6B 1A1', 'Colombie-Britannique'],
    ['Alberta', 'AB', 'T2P 1J9', 'Alberta'],
    ['Manitoba', 'MB', 'R3C 0V8', 'Manitoba'],
    ['Saskatchewan', 'SK', 'S4P 3Y2', 'Saskatchewan'],
    ['Nova Scotia', 'NS', 'B3H 1A1', 'Nouvelle-Écosse'],
    ['New Brunswick', 'NB', 'E1C 4M3', 'Nouveau-Brunswick'],
    ['Newfoundland and Labrador', 'NL', 'A1C 5M2', 'Terre-Neuve-et-Labrador'],
    ['Prince Edward Island', 'PE', 'C1A 4P3', 'Île-du-Prince-Édouard'],
    ['Yukon', 'YT', 'Y1A 2C6', 'Yukon'],
    ['Northwest Territories', 'NT', 'X1A 2P6', 'Territoires du Nord-Ouest'],
    ['Nunavut', 'NU', 'X0A 0H0', 'Nunavut']
  ];
  var T = FR
    ? { ship: 'Livraison vers', free: 'Gratuite', calc: 'Calculée à la commande', loading: '…', note: 'Livraison au Canada seulement.' }
    : { ship: 'Shipping to', free: 'Free', calc: 'Calculated at checkout', loading: '…', note: 'We ship within Canada only.' };

  function getProv() {
    var p = null;
    try { p = localStorage.getItem(KEY); } catch (e) {}
    for (var i = 0; i < PROV.length; i++) if (PROV[i][1] === p) return PROV[i];
    return PROV[0];
  }
  function setProv(code) { try { localStorage.setItem(KEY, code); } catch (e) {} }
  function getPostal() { try { return localStorage.getItem(POSTAL_KEY) || ''; } catch (e) { return ''; } }
  function setPostal(p) { try { if (p) localStorage.setItem(POSTAL_KEY, p); else localStorage.removeItem(POSTAL_KEY); } catch (e) {} }
  /* Canada Post forward sortation areas: first letter -> province (X0A/X0B/X0C are Nunavut). */
  function provFromPostal(postal) {
    var p = String(postal || '').toUpperCase().replace(/\s+/g, '');
    if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(p)) return null;
    var c = p.charAt(0);
    var map = { A: 'NL', B: 'NS', C: 'PE', E: 'NB', G: 'QC', H: 'QC', J: 'QC', K: 'ON', L: 'ON', M: 'ON', N: 'ON', P: 'ON', R: 'MB', S: 'SK', T: 'AB', V: 'BC', Y: 'YT' };
    if (c === 'X') return /^X0[ABC]/.test(p) ? 'NU' : 'NT';
    return map[c] || null;
  }
  function fmtPostal(p) { p = String(p || '').toUpperCase().replace(/\s+/g, ''); return p.length === 6 ? p.slice(0, 3) + ' ' + p.slice(3) : p; }

  function money(cents) {
    var v = (Number(cents) || 0);
    return FR ? v.toFixed(2).replace('.', ',') + ' $' : '$' + v.toFixed(2);
  }

  var CSS = '.elc-ship-est{margin:10px 0 2px;font-size:13px;line-height:1.5;letter-spacing:.02em;color:inherit;opacity:.92;display:flex;flex-wrap:wrap;align-items:center;gap:6px;justify-content:inherit}' +
    '.elc-ship-est select{font:inherit;color:inherit;background:transparent;border:1px solid rgba(201,168,76,.45);border-radius:2px;padding:2px 22px 2px 6px;cursor:pointer;-webkit-appearance:auto;appearance:auto}' +
    '.elc-ship-est select option{color:#111;background:#fff}' +
    '.elc-ship-est strong{color:#c9a84c;font-weight:600}' +
    '.elc-ship-est small{flex-basis:100%;opacity:.7;font-size:11.5px}';
  function addCss() {
    if (document.getElementById('elc-ship-est-css')) return;
    var s = document.createElement('style');
    s.id = 'elc-ship-est-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'elc-ship-est';
    wrap.setAttribute('aria-live', 'polite');
    var label = document.createElement('span');
    label.textContent = T.ship;
    var sel = document.createElement('select');
    sel.setAttribute('aria-label', T.ship);
    var cur = getProv()[1];
    PROV.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p[1];
      o.textContent = FR ? p[3] : p[0];
      if (p[1] === cur) o.selected = true;
      sel.appendChild(o);
    });
    var out = document.createElement('strong');
    out.className = 'elc-ship-est__val';
    out.textContent = T.loading;
    var note = document.createElement('small');
    note.textContent = T.note;
    wrap.appendChild(label);
    wrap.appendChild(sel);
    wrap.appendChild(document.createTextNode(':'));
    wrap.appendChild(out);
    wrap.appendChild(note);
    sel.addEventListener('change', function () {
      setProv(sel.value);
      /* A province picked by hand that no longer matches the checked postal code: back to the representative code. */
      if (provFromPostal(getPostal()) !== sel.value) setPostal('');
      document.querySelectorAll('.elc-ship-est select').forEach(function (s) { s.value = sel.value; });
      refresh(true);
    });
    return wrap;
  }

  function anchors() {
    var list = Array.prototype.slice.call(document.querySelectorAll('.tax-note'));
    if (list.length) return list;
    /* Fallback: the "Taxes, discounts and shipping calculated at checkout" line, found by its text. */
    var scope = document.querySelectorAll('cart-drawer small, cart-drawer p, #main-cart-footer small, #main-cart-footer p, .cart__footer small, .cart__footer p');
    return Array.prototype.filter.call(scope, function (el) {
      var t = (el.textContent || '').toLowerCase();
      return el.children.length < 3 && (t.indexOf('calculated at checkout') > -1 || t.indexOf('calculés à la') > -1 || t.indexOf('calculées à la') > -1);
    });
  }

  function place() {
    var placed = false;
    anchors().forEach(function (a) {
      var nx = a.nextElementSibling;
      if (nx && nx.classList && nx.classList.contains('elc-ship-est')) { placed = true; return; }
      a.insertAdjacentElement('afterend', build());
      placed = true;
    });
    return placed;
  }

  function render(text) {
    document.querySelectorAll('.elc-ship-est__val').forEach(function (el) { el.textContent = text; });
  }

  var last = { key: null, text: null };
  var inflight = null;

  function refresh(force) {
    if (!place()) return;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          document.querySelectorAll('.elc-ship-est').forEach(function (el) { el.style.display = 'none'; });
          return;
        }
        document.querySelectorAll('.elc-ship-est').forEach(function (el) { el.style.display = ''; });
        var p = getProv();
        var zip = p[2];
        var saved = getPostal();
        if (saved && provFromPostal(saved) === p[1]) zip = fmtPostal(saved);
        var sig = p[1] + '|' + zip + '|' + cart.total_price + '|' + cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
        if (!force && sig === last.key && last.text) { render(last.text); return; }
        if (inflight === sig) return;
        inflight = sig;
        render(T.loading);
        var q = 'shipping_address%5Bcountry%5D=Canada' +
          '&shipping_address%5Bprovince%5D=' + encodeURIComponent(p[0]) +
          '&shipping_address%5Bzip%5D=' + encodeURIComponent(zip);
        return fetch(ROOT + 'cart/shipping_rates.json?' + q, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('rates ' + r.status); return r.json(); })
          .then(function (d) {
            var rates = (d && d.shipping_rates) || [];
            var text = T.calc;
            if (rates.length) {
              var min = rates.reduce(function (m, r) { var v = parseFloat(r.price); return v < m ? v : m; }, Infinity);
              text = min === 0 ? T.free : money(min);
            }
            last = { key: sig, text: text };
            render(text);
          });
      })
      .catch(function () { render(T.calc); })
      .then(function () { inflight = null; });
  }

  var timer = null;
  function soon(force) { clearTimeout(timer); timer = setTimeout(function () { refresh(force); }, 350); }

  /* Called by the cart drawer after a successful FedEx lookup (and usable by anything else on the page). */
  window.elcShipEstPostal = function (postal) {
    var code = provFromPostal(postal);
    if (!code) return false;
    setPostal(String(postal).toUpperCase().replace(/\s+/g, ''));
    setProv(code);
    document.querySelectorAll('.elc-ship-est select').forEach(function (s) { s.value = code; });
    refresh(true);
    return true;
  };

  function init() {
    addCss();
    /* Postal code the drawer remembered (24 h) wins over the last province picked by hand. */
    try {
      var eta = JSON.parse(localStorage.getItem('elgFedexEta') || 'null');
      if (eta && eta.postal && Date.now() - (eta.ts || 0) < 86400000) {
        var c = provFromPostal(eta.postal);
        if (c) { setPostal(String(eta.postal).toUpperCase().replace(/\s+/g, '')); setProv(c); }
      }
    } catch (e) {}
    soon(false);
    /* Dawn publishes cart changes on its pub/sub bus. */
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { soon(true); });
      }
    } catch (e) {}
    /* The drawer re-renders its footer on every change; put the line back when it does. */
    if (window.MutationObserver) {
      var targets = [document.querySelector('cart-drawer'), document.getElementById('main-cart-footer')];
      targets.forEach(function (t) {
        if (!t) return;
        new MutationObserver(function () {
          var missing = false;
          anchors().forEach(function (a) {
            var nx = a.nextElementSibling;
            if (!(nx && nx.classList && nx.classList.contains('elc-ship-est'))) missing = true;
          });
          if (missing) soon(false);
        }).observe(t, { childList: true, subtree: true });
      });
    }
    /* Opening the drawer after an add-to-cart. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#cart-icon-bubble, [name="add"], .quick-add__submit')) soon(true);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
